import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Select, FormControl, FormLabel } from '@stockx/ui';
import { MonthSelectProps } from './MonthSelectProps';

const MonthSelect: React.FC<MonthSelectProps> = ({ setValue, name }) => {
  const { t } = useTranslation();

  const selectOptions = useMemo(
    () => [
      { value: '', text: t('Month') },
      { value: '0', text: t('January') },
      { value: '1', text: t('February') },
      { value: '2', text: t('March') },
      { value: '3', text: t('April') },
      { value: '4', text: t('May') },
      { value: '5', text: t('June') },
      { value: '6', text: t('July') },
      { value: '7', text: t('August') },
      { value: '8', text: t('September') },
      { value: '9', text: t('October') },
      { value: '10', text: t('November') },
      { value: '11', text: t('December') },
    ],
    [t],
  );

  return (
    <FormControl mt={4} mr={2}>
      <FormLabel mb={2} fontWeight={'bold'} htmlFor={name}>
        {t('Purchase Date')}
      </FormLabel>
      <Select
        id={name}
        name={name}
        data-testid="month-select-list"
        onChange={(e) => setValue(e.target.value)}
      >
        {selectOptions.map((option) => (
          <option key={option.value} value={option.value}>
            {option.text}
          </option>
        ))}
      </Select>
    </FormControl>
  );
};

export default MonthSelect;
